import type { AppTextName } from '../types/types'

export const APP_TEXT_TAG_MAP: Record<AppTextName, string> = {
  h2: 'h2',
  h3: 'h3',
  body1: 'p',
  'body1-medium': 'p',
  body2: 'p',
  'body2-medium': 'p',
}

export const APP_TEXT_BREAKPOINTS = [375, 740, 1024, 1280] as const
